export const CASUAL_PAGE_CONFIG = {
  "title": "Event Comparison",
  "titleCN": "事件对比",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/comparisonAnalysis/eventComparison",
  "defaultTab": "overall",
  "tabList": [
    {
      "id": "overall",
      "tabName": "Overall",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "notificationPath": "/comparisonAnalysis/eventComparison",
      "path": "/comparisonAnalysis/eventComparison",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "208501",
        "pageName": "iaaComparisonAnalysisEventComparison",
        "extInfo": "iaaComparisonAnalysisEventComparison",
        "pagePath": "/comparisonAnalysis/eventComparison"
      },
      "filters": [
        {
          "name": "MobileEventComparisonFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/comparisonAnalysis/eventComparison",
          "metricsList": [
            {
              "metric": "total_users",
              "metric_name_en": "{{metricsInfo.total_users.en}}",
              "metric_name_ch": "{{metricsInfo.total_users.cn}}"
            },
            {
              "metric": "new_users",
              "metric_name_en": "{{metricsInfo.new_users.en}}",
              "metric_name_ch": "{{metricsInfo.new_users.cn}}"
            },
            {
              "metric": "active_users",
              "metric_name_en": "{{metricsInfo.active_users_dau.en}}",
              "metric_name_ch": "{{metricsInfo.active_users_dau.cn}}"
            },
            {
              "metric": "iaa_revenue",
              "metric_name_en": "{{metricsInfo.iaa_revenue.en}}",
              "metric_name_ch": "{{metricsInfo.iaa_revenue.cn}}"
            },
            {
              "metric": "cpi",
              "metric_name_en": "{{metricsInfo.cpi.en}}",
              "metric_name_ch": "{{metricsInfo.cpi.cn}}"
            },
            {
              "metric": "af_cpi",
              "metric_name_en": "{{metricsInfo.af_cpi.en}}",
              "metric_name_ch": "{{metricsInfo.af_cpi.cn}}"
            },
            {
              "metric": "new_ch_organic_rate",
              "metric_name_en": "{{metricsInfo.organic_rate.en}}",
              "metric_name_ch": "{{metricsInfo.organic_rate.cn}}"
            },
            {
              "metric": "fraud_active_users_rate",
              "metric_name_en": "{{metricsInfo.fraud_active_users_rate_dau.en}}",
              "metric_name_ch": "{{metricsInfo.fraud_active_users_rate_dau.cn}}"
            },
            {
              "metric": "spend",
              "metric_name_en": "{{metricsInfo.spend.en}}",
              "metric_name_ch": "{{metricsInfo.spend.cn}}"
            },
            {
              "metric": "roi",
              "metric_name_en": "{{metricsInfo.roi.en}}",
              "metric_name_ch": "{{metricsInfo.roi.cn}}"
            },
            {
              "metric": "register_arpu",
              "metric_name_en": "{{metricsInfo.register_arpu.en}}",
              "metric_name_ch": "{{metricsInfo.register_arpu.cn}}"
            },
            {
              "metric": "arpu",
              "metric_name_en": "{{metricsInfo.arpu.en}}",
              "metric_name_ch": "{{metricsInfo.arpu.cn}}"
            },
            {
              "metric": "d2",
              "metric_name_en": "{{metricsInfo.d2.en}}",
              "metric_name_ch": "{{metricsInfo.d2.cn}}"
            },
            {
              "metric": "d3",
              "metric_name_en": "{{metricsInfo.d3.en}}",
              "metric_name_ch": "{{metricsInfo.d3.cn}}"
            },
            {
              "metric": "d4",
              "metric_name_en": "{{metricsInfo.d4.en}}",
              "metric_name_ch": "{{metricsInfo.d4.cn}}"
            },
            {
              "metric": "d5",
              "metric_name_en": "{{metricsInfo.d5.en}}",
              "metric_name_ch": "{{metricsInfo.d5.cn}}"
            },
            {
              "metric": "d6",
              "metric_name_en": "{{metricsInfo.d6.en}}",
              "metric_name_ch": "{{metricsInfo.d6.cn}}"
            },
            {
              "metric": "d7",
              "metric_name_en": "{{metricsInfo.d7.en}}",
              "metric_name_ch": "{{metricsInfo.d7.cn}}"
            },
            {
              "metric": "d14",
              "metric_name_en": "{{metricsInfo.d14.en}}",
              "metric_name_ch": "{{metricsInfo.d14.cn}}"
            },
            {
              "metric": "d30",
              "metric_name_en": "{{metricsInfo.d30.en}}",
              "metric_name_ch": "{{metricsInfo.d30.cn}}"
            },
            {
              "metric": "roas1",
              "metric_name_en": "{{metricsInfo.roas1.en}}",
              "metric_name_ch": "{{metricsInfo.roas1.cn}}"
            },
            {
              "metric": "roas2",
              "metric_name_en": "{{metricsInfo.roas2.en}}",
              "metric_name_ch": "{{metricsInfo.roas2.cn}}"
            },
            {
              "metric": "roas3",
              "metric_name_en": "{{metricsInfo.roas3.en}}",
              "metric_name_ch": "{{metricsInfo.roas3.cn}}"
            },
            {
              "metric": "roas7",
              "metric_name_en": "{{metricsInfo.roas7.en}}",
              "metric_name_ch": "{{metricsInfo.roas7.cn}}"
            },
            {
              "metric": "roas14",
              "metric_name_en": "{{metricsInfo.roas14.en}}",
              "metric_name_ch": "{{metricsInfo.roas14.cn}}"
            },
            {
              "metric": "roas30",
              "metric_name_en": "{{metricsInfo.roas30.en}}",
              "metric_name_ch": "{{metricsInfo.roas30.cn}}"
            },
            {
              "metric": "roas60",
              "metric_name_en": "{{metricsInfo.roas60.en}}",
              "metric_name_ch": "{{metricsInfo.roas60.cn}}"
            },
            {
              "metric": "roas90",
              "metric_name_en": "{{metricsInfo.roas90.en}}",
              "metric_name_ch": "{{metricsInfo.roas90.cn}}"
            },
            {
              "metric": "roas120",
              "metric_name_en": "{{metricsInfo.roas120.en}}",
              "metric_name_ch": "{{metricsInfo.roas120.cn}}"
            },
            {
              "metric": "roas180",
              "metric_name_en": "{{metricsInfo.roas180.en}}",
              "metric_name_ch": "{{metricsInfo.roas180.cn}}"
            },
            {
              "metric": "iaa_impressions",
              "metric_name_en": "{{metricsInfo.iaa_impressions.en}}",
              "metric_name_ch": "{{metricsInfo.iaa_impressions.cn}}"
            },
            {
              "metric": "avg_active_user_matches",
              "metric_name_en": "{{metricsInfo.avg_active_user_matches.en}}",
              "metric_name_ch": "{{metricsInfo.avg_active_user_matches.cn}}"
            },
            {
              "metric": "avg_new_user_matches",
              "metric_name_en": "{{metricsInfo.avg_new_user_matches.en}}",
              "metric_name_ch": "{{metricsInfo.avg_new_user_matches.cn}}"
            },
            {
              "metric": "aot",
              "metric_name_en": "{{metricsInfo.aot.en}}",
              "metric_name_ch": "{{metricsInfo.aot.cn}}"
            },
            {
              "metric": "new_aot",
              "metric_name_en": "{{metricsInfo.new_aot.en}}",
              "metric_name_ch": "{{metricsInfo.new_aot.cn}}"
            },
            {
              "metric": "retention_users",
              "metric_name_en": "DAU Retention Users",
              "metric_name_ch": "日活留存"
            },
            {
              "metric": "churn_users",
              "metric_name_en": "{{metricsInfo.churn_users.en}}",
              "metric_name_ch": "{{metricsInfo.churn_users.cn}}"
            },
            {
              "metric": "churn_rate",
              "metric_name_en": "{{metricsInfo.churn_rate.en}}",
              "metric_name_ch": "{{metricsInfo.churn_rate.cn}}"
            },
            {
              "metric": "return_users",
              "metric_name_en": "{{metricsInfo.avg_return_users_dau.en}}",
              "metric_name_ch": "{{metricsInfo.avg_return_users_dau.cn}}"
            },
            {
              "metric": "weighted_d2",
              "metric_name_en": "{{metricsInfo.weighted_d2.en}}",
              "metric_name_ch": "{{metricsInfo.weighted_d2.cn}}"
            },
            {
              "metric": "weighted_d3",
              "metric_name_en": "{{metricsInfo.weighted_d3.en}}",
              "metric_name_ch": "{{metricsInfo.weighted_d3.cn}}"
            },
            {
              "metric": "weighted_d7",
              "metric_name_en": "{{metricsInfo.weighted_d7.en}}",
              "metric_name_ch": "{{metricsInfo.weighted_d7.cn}}"
            },
            {
              "metric": "first_login_ratio",
              "metric_name_en": "{{metricsInfo.first_login_ratio.en}}",
              "metric_name_ch": "{{metricsInfo.first_login_ratio.cn}}"
            },
            {
              "metric": "second_login_ratio",
              "metric_name_en": "{{metricsInfo.second_login_ratio.en}}",
              "metric_name_ch": "{{metricsInfo.second_login_ratio.cn}}"
            }
          ],
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "MetricComponent",
                  "path": "eventAnalysis/eventComparison",
                  "componentKey": "ComparisonMetricsTrendCo",
                  "height": 500,
                  "className": "margin-t-20"
                },
                {
                  "name": "MetricComponent",
                  "path": "eventAnalysis/eventComparison",
                  "componentKey": "ComparisonTableCo",
                  "height": 500,
                  "className": "margin-t-20"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
